import {
  RuleCategoryEnum,
  RuleNameEnum,
  RuleSeverityEnum,
} from '@/__generated__/graphql';
import { toTitleCase } from '@/util/string';

export const RULE_NAMES = Object.values(RuleNameEnum);

export const RULE_CATEGORY = Object.values(RuleCategoryEnum);

export const RULE_SEVERITY = [
  RuleSeverityEnum.High,
  RuleSeverityEnum.Medium,
  RuleSeverityEnum.Low,
];

export const formatDisplayedName = (ruleName: string) => {
  return toTitleCase(ruleName.toLowerCase().replaceAll('_', ' '));
};
